import { Landmark } from "lucide-react";

const TuitionTileDesign = {
  id: "tuition",
  icon: Landmark,
  label: "Tuition",
  background: "linear-gradient(135deg, var(--color-primary-dark), var(--color-primary))",
  color: "#ffffff",
};

export default TuitionTileDesign;
